export enum SignUpPointErrors {
  INCORRECT_NAME = 'Пожалуйста, введите корректрное название точки.',
  INCORRECT_ADDRESS = 'Пожалуйста, введите корректрный адресс точки.',
  INCORRECT_PHONE = 'Пожалуйста, введите корректный номер телефона.',
  INCORRECT_LINK = 'Пожалуйста, введите корректнyю ссылку на сайт организации.',
  INCORRECT_DESCRIPTION = 'Не корректное описание точки.',
}
